import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {FireInTheHole2} from "../../FireInTheHole2";
import {APISetting} from "@nolimit/slot-launcher/bin/interfaces/APISettingsSystem";
import {FreespinSymbol} from "../../symbols/freespin/FreespinSymbol";
import {NolimitConfig} from "@nolimit/slot-launcher/bin/settings/NolimitConfig";
import {IFSStepData} from "../../server/FITH2Model";


export class SideTrainUpgrade implements SimplePresentation {
    name: string = "FreespinStopPresentation";

    constructor() {
    }

    shouldRun(): boolean {
        return FireInTheHole2.model.fsSteps.length>0;
    }

    private checkWithServer(i: number, j: number): void {
        const evaluatedArea: string[][] = FireInTheHole2.model.gameData.reelsAfterCollapse;
        const symbol: FreespinSymbol = FireInTheHole2.freespinReelArea.getSymbol([i, j]);
        if (symbol.symName != evaluatedArea[i][j]) {
            debugger
        }
    }

    private checkDataWithServer(): void {

    }

    start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(3);
        }));
        FireInTheHole2.model.fsSteps.forEach((step: IFSStepData) => {
                if (step.necromancer) {
                    tl.add(FireInTheHole2.freespinReelArea.necromanceCoins(step.necromancer));
                }

                if (step.dynamites) {
                    tl.add(FireInTheHole2.freespinReelArea.throwDynamites(step.dynamites, step.id));
                }

                if (step.collectorPos) {
                    tl.add(FireInTheHole2.freespinReelArea.dwarfCollectAnimation(step));
                }

                if (step.reelMultiplier) {
                    tl.add(FireInTheHole2.freespinReelArea.spreadReelMultiplier(step.reelMultiplier, step.id));
                }
        });
        if (NolimitConfig.isDevMode) {
           this.checkDataWithServer();
        }
        tl.add(() => controller.finish());

        if (FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            tl.timeScale(1.4);
        }
    }
}